import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-logger",
  "use": "dv-logger-usage",
  "viewBox": "0 0 15.04 20",
  "content": "<symbol viewBox=\"0 0 15.04 20\" id=\"dv-logger\"><title>dv-logger</title><path d=\"M16.6,3.85H15.48V.62a.62.62,0,0,0-1.23,0V3.85H7.06a.92.92,0,0,0-.92.92V8.62H3.4a.92.92,0,0,0-.92.92v4.77a.92.92,0,0,0,.92.92H6.13v3.85a.92.92,0,0,0,.92.92h8.19a.92.92,0,0,0,.92-.92V9.77a.46.46,0,0,1,.46-.46h.88V4.77A.92.92,0,0,0,16.6,3.85Z\" transform=\"translate(-2.48)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-logger.svg
// module id = rK07
// module chunks = 264